import {
  Box,
  Grid,
  Stack,
  TextField,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import {
  ErrorTypography,
  SecondaryTypography,
  StyledTypography,
} from "../../../Theme";
import PhoneInput from "react-phone-input-2";
import { validateProjectDetails } from "../../../utils/validate";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState, useEffect } from "react";
import axiosInstance from "../../../AxiosInstance";

const ProjectInformation = ({
  projectDetails,
  setProjectDetails,
  projectDetailsErrText,
  setProjectDetailsErrText,
  setaddblocks,
  projectTypes,
}) => {
  const [CountryList, setCountryList] = useState([]);
  const [CityList, setCityList] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}getDropDownDatas?type=country`)
      .then((res) => {
        setCountryList(res.data.data?.drop_down);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "country" && value) {
      setCityList([]);
      const selectedCountry = value;
      const selectedCountryObject = CountryList.find(
        (city) => city.country === selectedCountry
      );
      setCityList(selectedCountryObject?.city);
    }
    setProjectDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    setProjectDetailsErrText((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleContinue = () => {
    if (
      validateProjectDetails(
        projectDetails,
        projectDetailsErrText,
        setProjectDetailsErrText
      )
    ) {
      // Navigate to next page
      setaddblocks({
        Company_Details: false,
        Project_Information: false,
        Administrator_Details: true,
        Review_Account: false,
      });
    }
  };

  const handlePhoneChange = (value, countryData) => {
    const dialCode = countryData.dialCode; // Country's dial code

    setProjectDetails((prev) => ({
      ...prev,
      contact_number: value, // Dynamically set phone number
      country_code: dialCode, // Dynamically set country code
    }));

    setProjectDetailsErrText((prev) => ({
      ...prev,
      contact_number: "", // Reset error for phone number field
    }));
  };
  console.log("project", projectDetails, "ERR", projectDetailsErrText);
  return (
    <>
      <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <SecondaryTypography>Project Information</SecondaryTypography>
        </Stack>
        <Box component="form">
          <Grid
            container
            xs={12}
            gap="20px"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12} md={5.77}>
              <StyledTypography>Project Title</StyledTypography>
              <TextField
                name="project_title"
                placeholder="Enter Project Title"
                onChange={handleInputChange}
                value={projectDetails?.project_title || ""}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 100 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.project_title
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.project_title
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.project_title && (
                <ErrorTypography>
                  {projectDetailsErrText.project_title}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Type</StyledTypography>

              <Select
                sx={{
                  color: projectDetailsErrText.type ? "#912018" : "#111927",

                  backgroundColor: projectDetailsErrText.type
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                name="type"
                displayEmpty
                onChange={(e) => {
                  console.log("e", e.target.name, e.target.value);
                  setProjectDetails((prev) => ({
                    ...prev,

                    type: e.target.value,
                  }));
                  setProjectDetailsErrText((prev) => ({
                    ...prev,
                    type: "",
                  }));
                }} // Ensure the correct handler is used
                value={projectDetails?.type?.name}
                renderValue={() => projectDetails?.type?.name || "Select Type"}
              >
                {projectTypes?.map((itm, index) => {
                  return (
                    <MenuItem key={index} value={itm}>
                      {itm?.name}{" "}
                      {/* Assuming itm is an object with a name property */}
                    </MenuItem>
                  );
                })}
              </Select>
              {projectDetailsErrText?.type && (
                <ErrorTypography>{projectDetailsErrText?.type}</ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Completion Year</StyledTypography>
              <TextField
                name="completion_year"
                value={projectDetails?.completion_year || ""}
                placeholder="Enter Completion Year"
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.completion_year
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.completion_year
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.completion_year && (
                <ErrorTypography>
                  {projectDetailsErrText.completion_year}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Tenure</StyledTypography>
              <TextField
                name="tenure"
                placeholder="Enter Tenure"
                value={projectDetails?.tenure || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.tenure ? "#912018" : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.tenure
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.tenure && (
                <ErrorTypography>
                  {projectDetailsErrText.tenure}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>No. of Units</StyledTypography>
              <TextField
                name="units"
                placeholder="No. of Units"
                value={projectDetails?.units || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 100 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.units ? "#912018" : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.units
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.units && (
                <ErrorTypography>{projectDetailsErrText.units}</ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Address</StyledTypography>
              <TextField
                name="address"
                placeholder="Enter Address"
                value={projectDetails?.address || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 1000 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.address
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.address && (
                <ErrorTypography>
                  {projectDetailsErrText.address}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Country</StyledTypography>
              <Select
                value={projectDetails?.country || ""}
                onChange={handleInputChange}
                name="country"
                IconComponent={KeyboardArrowDownIcon}
              >
                {CountryList.length > 0 &&
                  CountryList.map((value) => (
                    <MenuItem key={value?.key} value={value?.country}>
                      {value?.country}
                    </MenuItem>
                  ))}
              </Select>
              {/* <TextField
                name="country"
                placeholder="Enter Country"
                value={projectDetails?.country || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 20 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.country
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.country
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              /> */}
              {projectDetailsErrText.country && (
                <ErrorTypography>
                  {projectDetailsErrText.country}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>City / Province</StyledTypography>
              <Select
                value={projectDetails?.city || ""}
                onChange={handleInputChange}
                name="city"
                IconComponent={KeyboardArrowDownIcon}
              >
                {CityList.length > 0 &&
                  CityList.map((city) => (
                    <MenuItem value={city}>{city}</MenuItem>
                  ))}
              </Select>
              {/* <TextField
                name="city"
                placeholder="Enter The City"
                value={projectDetails?.city || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 20 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.city ? "#912018" : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.city
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              /> */}
              {projectDetailsErrText.city && (
                <ErrorTypography>{projectDetailsErrText.city}</ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Postal Code</StyledTypography>
              <TextField
                name="postal_code"
                onChange={handleInputChange}
                value={projectDetails?.postal_code || ""}
                placeholder="Postal Code"
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 7 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.postal_code
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.postal_code
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.postal_code && (
                <ErrorTypography>
                  {projectDetailsErrText.postal_code}
                </ErrorTypography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <SecondaryTypography>Point of Contact</SecondaryTypography>
        </Stack>
        <Box component="form">
          <Grid
            container
            xs={12}
            gap="20px"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12} md={5.77}>
              <StyledTypography>Full Name</StyledTypography>
              <TextField
                name="full_name"
                placeholder="Enter Full Name"
                value={projectDetails?.full_name || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 50 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.full_name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.full_name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.full_name && (
                <ErrorTypography>
                  {projectDetailsErrText.full_name}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Position</StyledTypography>
              <TextField
                name="position"
                value={projectDetails?.position || ""}
                placeholder="Position"
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 50 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.position
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.position
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.position && (
                <ErrorTypography>
                  {projectDetailsErrText.position}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Email Address</StyledTypography>
              <TextField
                name="email_address"
                placeholder="Enter Email Address"
                value={projectDetails?.email_address || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: projectDetailsErrText.email_address
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: projectDetailsErrText.email_address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {projectDetailsErrText.email_address && (
                <ErrorTypography>
                  {projectDetailsErrText.email_address}
                </ErrorTypography>
              )}
            </Grid>
            <Grid item xs={12} md={5.77}>
              <StyledTypography style={{ marginBottom: "10px" }}>
                Contact Number
              </StyledTypography>
              <PhoneInput
                inputProps={{ name: "contact_number", maxLength: 20 }}
                country={process.env.REACT_APP_COUNTRY_CODE || "sg"}
                placeholder="Enter Contact Number"
                value={projectDetails?.contact_number || ""}
                buttonStyle={{ border: "none" }}
                onChange={handlePhoneChange}
                inputStyle={{
                  backgroundColor: projectDetailsErrText?.contact_number
                    ? "#FEE4E2"
                    : "#F9FAFB",
                  border: "none",
                  height: "46px",
                  width: "100%",
                  color: projectDetailsErrText.contact_number
                    ? "#912018"
                    : "#111927",
                  borderRadius: "8px",
                }}
                countryCodeEditable={false}
              />
              {projectDetailsErrText.contact_number && (
                <ErrorTypography>
                  {projectDetailsErrText.contact_number}
                </ErrorTypography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        mt={3}
        bgcolor="#FFFFFF"
        sx={{
          border: "1px solid  #E5E7EB",
          borderTop: " 1px solid #F3F4F6",
          boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
          borderRadius: "8px 8px 8px 8px",
        }}
      >
        <Stack
          direction="row"
          py={1}
          px={1}
          justifyContent="end"
          alignItems="center"
          height="60px"
        >
          <Stack direction="column" justifyContent="end" alignItems="end">
            <Button onClick={handleContinue} type="button" variant="Standard">
              Continue
            </Button>
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default ProjectInformation;
